export default __webpack_public_path__ + "static/media/Belt of Haloga.583ad3bd.jpg";